import React, {} from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
//import ARButton from "./components/ar3d/ar/ARButton";
//import ARButtonWebXR from "./components/ar3d/ARButtonWebXR";
import {DEVICE_TYPE, getDeviceType} from "./helpers/sqftMobileHelper";
import ARButtonGoogleWebXR from "./components/ar3d/ar/ARButtonGoogleWebXR";
import ARViewUSDZButton from "./components/ar3d/ar/ARViewUSDZButton";

const SQFTPageAR = (props) => {
  const {match} = props;
  const files = match.params ? JSON.parse(decodeURIComponent(match.params.file)) : null;

  const usdzLink = files.find(link => link.endsWith('.usdz'));
  const glbLink = files.find(link => link.endsWith('.glb'));

  const getArButton = () => {
    switch (getDeviceType()) {
      case DEVICE_TYPE.Android:
        return <ARButtonGoogleWebXR url={glbLink} />
      case DEVICE_TYPE.iOS:
      case DEVICE_TYPE.unknown:
        return <ARViewUSDZButton url={usdzLink} />
    }
  }

  return (
    <div className="sqft">
      <div className="ar-page">
        {/*<img src={qrImage} alt='' />*/}
        {getArButton()}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(SQFTPageAR)
  )
);
